export enum ResponseType {
  Undefined = "Undefined",
  Interested = "Interested",
  NotInterested = "NotInterested",
}
